'use client';

import React from 'react';

import Button, { type ButtonVariant } from '../buttons/Button';

export type InputActionProps = {
  id: string;
  label?: React.ReactNode;
  buttonLabel: React.ReactNode;
  buttonVariant?: ButtonVariant;
  buttonDisabled?: boolean;
  buttonType?: 'button' | 'submit' | 'reset';
  onButtonClick?: React.MouseEventHandler<HTMLButtonElement>;
  hint?: React.ReactNode;
  className?: string;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'id'>;

const InputAction = React.forwardRef<HTMLInputElement, InputActionProps>(
  (
    {
      id,
      label,
      buttonLabel,
      buttonVariant = 'primary',
      buttonDisabled,
      buttonType = 'submit',
      onButtonClick,
      hint,
      className = '',
      ...props
    },
    ref
  ) => {
    return (
      <fieldset className={`input-action${className ? ` ${className}` : ''}`}>
        {label ? <label htmlFor={id}>{label}</label> : null}
        <div className='controls'>
          <input id={id} ref={ref} type='text' {...props} />
          <Button
            type={buttonType}
            variant={buttonVariant}
            label={buttonLabel}
            disabled={buttonDisabled}
            onClick={onButtonClick}
          />
        </div>
        {hint ? <small className='hint'>{hint}</small> : null}
      </fieldset>
    );
  }
);

InputAction.displayName = 'InputAction';

export default InputAction;
